import libs from  '../../libs.js'

const state = {
  userRoles: {
    offset: 0,
    limit: 10,
    data: [],
    total: 0
  },
  userRole: {},
  permissions: {
    data: [],
    total: 0
  },
  users: {
    offset: 0,
    limit: 10,
    data: [],
    total: 0
  },
  user: {}
}

const getters = {
  userRoles: (state) => state.userRoles,
  userRole: (state) => state.userRole,
  permissions: (state) => state.permissions,
  users: (state) => state.users,
  user: (state) => state.user
}

const actions = {
  loadUserRoles: async function ({ commit }, query = {}) {
    commit('setLoading', 'memuat daftar grup pengguna')

    const newQuery = libs.generateQuery(query, {
      offset: state.userRoles.offset,
      limit: state.userRoles.limit
    })

    const listUserRoles = await this.dispatch('authenticatedApi', {
      method: 'get',
      url: `${window.config.BASEURL_API1}/roles?${newQuery.toString}`
    })

    if (listUserRoles) {
      commit('setUserRoles', {
        offset: newQuery.query.offset,
        limit: newQuery.query.limit,
        data: listUserRoles.data.roles,
        total: listUserRoles.data.total
      })
    }

    commit('unsetLoading')
  },
  loadUserRole: async function ({ commit }, roleId) {
    commit('setLoading', 'memuat grup pengguna')

    const userRole = await this.dispatch('authenticatedApi', {
      method: 'get',
      url: `${window.config.BASEURL_API1}/role/${roleId}`
    })

    if (userRole) {
      try {
        userRole.data.preset.wpp = JSON.parse(userRole.data.preset.wpp)
        userRole.data.preset.kapal = JSON.parse(userRole.data.preset.kapal)
      } catch (err) {
        userRole.data.preset.wpp = {}
        userRole.data.preset.kapal = {}
      }

      commit('setUserRole', {
        role: userRole.data.role,
        preset: userRole.data.preset,
        permissions: userRole.data.permissions
      })
    }

    commit('unsetLoading')
  },
  loadPermissions: async function ({ commit }) {
    commit('setLoading', 'memuat izin akses')

    const listPermissions = await this.dispatch('authenticatedApi', {
      method: 'get',
      url: `${window.config.BASEURL_API1}/permissions?offset=0&limit=1000`
    })

    if (listPermissions) {
      commit('setPermissions', {
        data: listPermissions.data.permissions,
        total: listPermissions.data.total
      })
    }

    commit('unsetLoading')
  },
  toAddUserRole: async function ({ commit, dispatch }, userRole) {
    commit('setLoading', 'menambah grup pengguna')

    const newRole = await dispatch('authenticatedApi', {
      method: 'post',
      url: `${window.config.BASEURL_API1}/role`,
      data: userRole
    })

    commit('unsetLoading')

    return newRole ? newRole.data.role_id : null;
  },
  editUserRole: async function ({ commit }, userRole) {
    commit('setLoading', 'memuat grup pengguna')

    await this.dispatch('authenticatedApi', {
      method: 'put',
      url: `${window.config.BASEURL_API1}/role`,
      data: userRole
    })

    commit('unsetLoading')
  },
  toDeleteUserRole: async function ({ commit, dispatch }, roleId) {
    commit('setLoading', 'menghapus grup pengguna')

    await dispatch('authenticatedApi', {
      method: 'delete',
      url: `${window.config.BASEURL_API1}/role/${roleId}`
    })

    commit('unsetLoading')
  },
  addRolePermission: async function ({ commit, dispatch }, permission) {
    commit('setLoading', 'menambah izin akses')

    await dispatch('authenticatedApi', {
      method: 'post',
      url: `${window.config.BASEURL_API1}/role-permission`,
      data: {
        role_id: permission.role_id,
        permission_id: permission.permission_id
      }
    })

    commit('unsetLoading')
  },
  deleteRolePermission: async function ({ commit, dispatch }, rolePermissionId) {
    commit('setLoading', 'menghapus izin akses')

    await dispatch('authenticatedApi', {
      method: 'delete',
      url: `${window.config.BASEURL_API1}/role-permission/${rolePermissionId}`
    })

    commit('unsetLoading')
  },
  loadUsers: async function ({ commit }, query) {
    commit('setLoading', 'memuat daftar pengguna')

    const newQuery = libs.generateQuery(query, {
      offset: state.users.offset,
      limit: state.users.limit
    })

    const listUser = await this.dispatch('authenticatedApi', {
      method: 'get',
      url: `${window.config.BASEURL_API1}/users?${newQuery.toString}`
    })

    if (listUser) {
      commit('setUsers', {
        offset: newQuery.query.offset,
        limit: newQuery.query.limit,
        data: listUser.data.users,
        total: listUser.data.total
      })
    }

    commit('unsetLoading')
  },
  loadUser: async function ({ commit }, userId) {
    commit('setLoading', 'memuat daftar pengguna')

    const user = await this.dispatch('authenticatedApi', {
      method: 'get',
      url: `${window.config.BASEURL_API1}/user/${userId}`
    })

    if (user) {
      commit('setUser', user.data.user)
    }

    commit('unsetLoading')
  },
  editUser: async function ({ commit }, user) {
    commit('setLoading', 'memperbaharui data pengguna')

    await this.dispatch('authenticatedApi', {
      method: 'put',
      url: `${window.config.BASEURL_API1}/user`,
      data: user
    })

    commit('unsetLoading')
  },
  addUser: async function ({ commit }, user) {
    commit('setLoading', 'memperbaharui data pengguna')

    await this.dispatch('authenticatedApi', {
      method: 'post',
      url: `${window.config.BASEURL_API1}/user`,
      data: user
    })

    commit('unsetLoading')
  },
  toDeleteUser: async function ({ commit, dispatch }, userId) {
    commit('setLoading', 'menghapus pengguna')

    await dispatch('authenticatedApi', {
      method: 'delete',
      url: `${window.config.BASEURL_API1}/user/${userId}`
    })

    commit('unsetLoading')
  }
}

const mutations = {
  setUserRoles: (state, userRoles) => state.userRoles = userRoles,
  setUserRole: (state, userRole) => state.userRole = userRole,
  setPermissions: (state, permissions) => state.permissions = permissions,
  setUsers: (state, users) => state.users = users,
  setUser: (state, user) => state.user = user
}

export default {
  state,
  getters,
  actions,
  mutations
}
